import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../context/LoginContext";
import { useDataBase } from "../context/DataBaseContext";
import { supabase } from "../supabase/client";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import TitleBox from "../components/common/TitleBox";
import ContainerBox from "../components/common/ContainerBox";
import Button from "../components/common/Button";
import {
  IconEdit,
  IconElipsis,
  IconLink,
  IconPlus,
  IconTrash,
} from "../components/icons/Icons";
import TableData from "../components/common/TableData";
import Modal from "../components/common/Modal";
import Form from "../components/calendar/Form";
import Input from "../components/common/Input";
import VideosForm from "../components/forms/VideosForm";

const AudienciasPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalEnlace, setIsModalEnlace] = useState(false);
  const [modalOptions, setModalOptions] = useState(false);
  const [modalVideo, setModalVideo] = useState(false);
  const [modalNuevoVideo, setModalNuevoVideo] = useState(false);
  const [audiencia, setAudiencia] = useState(null);
  const [enlaceVideo, setEnlaceVideo] = useState(null);
  const [videos, setVideos] = useState(null);
  const [idData, setIdData] = useState(null);

  const MySwal = withReactContent(Swal)
  const { audiencias, getAudiencias } = useDataBase();

  const navigate = useNavigate();
  const { user } = useLogin();

  useEffect(() => {
    if (user !== null) {
      navigate("/audiencias");
    }
    getAudiencias();
  }, [user]);

  // useEffect(() => {
  //   if (idData !== null)
  //     getAudiencia(idData)
  // }, [idData])
  

  const columns = [
    {
      header: "#",
      cell: ({ cell }) => {
        const { row } = cell;
        return <div>{row.index + 1}</div>;
      },
    },
    {
      header: "Expediente",
      accessorFn: (row) =>
        row.process !== null
          ? `${row.process.num_process}-${row.process.anio_process}-${row.process.class_process.name}`
          : "",
    },
    {
      header: "Fecha",
      accessorKey: "date",
    },
    {
      header: "Detalle",
      accessorKey: "title",
    },
    {
      header: "Secretario",
      accessorFn: (row) =>
        row.process !== null
          ? `${row.secretaries.users.first_name} ${row.secretaries.users.last_name}`
          : "",
    },
    {
      header: "Acciones",
      cell: ({ cell }) => {
        const id = cell.row.original.id;
        return (
          <div className="flex items-center">
            <button
              className="bg-primary/80 hover:bg-primary border border-primary/80 text-xs text-white w-8 h-8 flex items-center justify-center rounded-sm"
              title="Más"
              onClick={async () => {
                setModalOptions(true);
                // await getAudiencia(id);
                // openModal();
                setIdData(id);
              }}
            >
              <IconElipsis className="w-4" />
            </button>
            <button
              className="bg-success/80 hover:bg-success border border-success/80 text-xs text-white w-8 h-8 flex items-center justify-center rounded-sm"
              title="Enlace"
              onClick={async () => {
                await getEnlaceVideo(id);
                setIsModalEnlace(true);
                setIdData(id);
              }}
            >
              <IconLink className="w-4" />
            </button>
            <button
              className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 w-8 h-8 flex items-center justify-center rounded-sm"
              title="Editar"
              onClick={async () => {
                await getAudiencia(id);
                openModal();
                // setIdData(id);
              }}
            >
              <IconEdit className="w-4" />
            </button>
            <button
              className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white w-8 h-8 flex items-center justify-center rounded-sm"
              title="Eliminar"
              onClick={openModal}
            >
              <IconTrash className="w-4" />
            </button>
          </div>
        );
      },
    },
  ];

  const columnsVideos = [
    {
      header: "#",
      cell: ({ cell }) => {
        const { row } = cell;
        return <div>{row.index + 1}</div>;
      },
    },
    {
      header: "Fecha",
      accessorKey: "date",
    },
    {
      header: "Descripción",
      accessorKey: "description",
    },
    {
      header: "Link",
      accessorKey: "link",
    },
    {
      header: "Acciones",
      cell: ({ cell }) => {
        const id = cell.row.original.id;
        return (
          <div className="flex items-center">
            <button
              className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 w-8 h-8 flex items-center justify-center rounded-sm"
              title="Editar"
              onClick={async () => {
                await getAudiencia(id);
                openModal();
                // setIdData(id);
              }}
            >
              <IconEdit className="w-4" />
            </button>
            <button
              className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white w-8 h-8 flex items-center justify-center rounded-sm"
              title="Eliminar"
              onClick={openModal}
            >
              <IconTrash className="w-4" />
            </button>
          </div>
        );
      },
    },
  ]

  const getAudiencia = async (id) => {
    const { data, error } = await supabase
      .from("audiences")
      .select()
      .eq("id", id)
      .single();
    if (error) {
      console.error("Error:", error);
      return;
    }
    const date = data.date + " " + data.start;
    const end = data.date + " " + data.end;
    const formattedEvents = {
      ...data,
      start: date,
      end: end,
    };
    
    setAudiencia(formattedEvents);
  }
  
  const getVideos = async (id) => {
    const { data, error } = await supabase
      .from("audience_videos")
      .select()
      .eq("audiences_id", id)
    if (error) {
      console.error("Error:", error);
      return;
    }
    
    setVideos(data);
  }
  
  const getEnlaceVideo = async (id) => {
    const { data, error } = await supabase
      .from("audiences")
      .select('link')
      .eq("id", id)
      .single();
    if (error) {
      console.error("Error:", error);
      return;
    }
    if (data.link !== null) {
      setEnlaceVideo(data.link);
    }else{
      setEnlaceVideo(null);
    }
  }

  const updateEnlaceAudiencia = async (id) => {
    const { error } = await supabase
      .from("audiences")
      .update({ link: enlaceVideo })
      .eq("id", id)
      .single();
    if (error) {
      console.error("Error:", error);
      return;
    }
    MySwal.fire({
      position: "center",
      icon: "success",
      title: "Enlace actualizado correctamente",
      showConfirmButton: false,
      timer: 1500
    });
  }

  const openModal = () => {
    // if (id !== null) {
    //   getAudiencia(id);
    // }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="pb-5">
      <TitleBox title="Relación de audiencias" />
      <ContainerBox>
        <Button value="Nuevo" openModal={() => openModal()}>
          <IconPlus className="w-4" />
        </Button>
        <TableData columns={columns} data={audiencias} />
      </ContainerBox>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        isModal={false}
        title="Nuevo registro"
      >
        <div className="h-full overscroll-contain w-full flex flex-col md:flex-row items-center gap-4">
          <Form onClose={closeModal} dataEvent={audiencia} />
        </div>
      </Modal>
      <Modal
        isOpen={isModalEnlace}
        onClose={() => setIsModalEnlace(false)}
        title="Enlace de audiencia"
      >
        
          <div className="w-full space-y-4">
            <Input
              textLabel="Enlace audiciencia"
              className="w-3/4"
              type="text"
              name="link"
              placeholder="Ej. https://www.ejemplo.com/conferencia"
              value={enlaceVideo || ""}
              onChange={(e) => {
                setEnlaceVideo(e.target.value);
              }}
            />
            <div className="flex gap-3 justify-end">
              <button
                className="max-w-fit bg-secondary hover:bg-secondary/90 border border-secondary text-white px-3 py-1 rounded-sm flex items-center gap-1 font-light"
                onClick={() => setIsModalEnlace(false)}
              >
                Cerrar
              </button>
              <button
                className="max-w-fit bg-primary hover:bg-primary/90 border border-primary text-white px-3 py-1 rounded-sm flex items-center gap-1 font-light"
                onClick={async () => {
                  await updateEnlaceAudiencia(idData);
                  setIsModalEnlace(false);
                }}
              >
                Actualizar
              </button>
            </div>
          </div>
        
      </Modal>
      <Modal
        isOpen={modalOptions}
        onClose={() => setModalOptions(false)}
        title={"Opciones adicionales"}
        modalSize="md"
      >
        <div className="h-full overscroll-contain w-full flex flex-wrap justify-center md:flex-row items-center gap-4">
          <button
            className="text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 text-center inline-flex items-center gap-1"
            type="button"
            onClick={async () => {
              // await getVideos(idData);
              // setModalAudiencias(true);
              setModalOptions(false);
            }}
          >
            Pautas Preliminares
          </button>
          <button
            className="text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 text-center inline-flex items-center gap-1"
            type="button"
            onClick={async () => {
              await getVideos(idData);
              setModalVideo(true);
              setModalOptions(false);
            }}
          >
            Videos
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={modalVideo}
        onClose={() => setModalVideo(false)}
        title={"Videos"}
      >
        <Button value="Nuevo" openModal={() => setModalNuevoVideo(true)}>
          <IconPlus className="w-4" />
        </Button>
        <TableData columns={columnsVideos} data={videos} />
      </Modal>
      <Modal
        isOpen={modalNuevoVideo}
        onClose={() => setModalNuevoVideo(false)}
        title="Nuevo video"
        modalSize="md"
      >
        <div className="h-full overscroll-contain w-full flex flex-col md:flex-row items-center gap-4">
          <VideosForm />
        </div>
      </Modal>
    </div>
  );
};
export default AudienciasPage;
